import { useEffect, useState } from "react";
import { GetLogRouteListReqQuery } from "../types/logRouteContract";
import { LogRoute } from "../types/logRoute";
import apiGetLogRouteList from "../api/logRoute/apiGetLogRouteList";
import { useAppContext } from "../contexts/DataContext";
import { useLoadingContext } from "../contexts/LoadingContext";
import { ErrorI } from "../types/api";

const useLogRouteList = (query?: GetLogRouteListReqQuery) => {
  const { incrementLoading, decrementLoading } = useLoadingContext()
  const {dispatch}= useAppContext()
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<LogRoute[]>([]);

  useEffect(() => {
    isLoading ? incrementLoading() : decrementLoading();
  }, [isLoading])

  const get = async (newQuery?: GetLogRouteListReqQuery) => {
    if (newQuery) query = newQuery;

    let resData: LogRoute[] | undefined = undefined;
    let error: ErrorI | undefined = undefined;

    try {
      setIsLoading(true);

      const res = await apiGetLogRouteList(query);

      setData(res.json.data);
      dispatch({
        type: 'GET',
        payload: {
          type: 'logRoutes',
          data: res.json.data
        }
      });
      resData = res.json.data;
    } catch (err) {
      // TODO!: error handler
      console.error(err);
      if ("message" in (err as ErrorI)) {
        error = err as ErrorI;
      }
    } finally {
      setIsLoading(false);
    }

    return { resData, error };
  };

  return {
    data,
    isLoading,
    get,
  };
};

export default useLogRouteList;
